import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CheckCircle } from "../../../assets/img/icon/check_circle_black_24dp.svg";
import { ReactComponent as ErrorBlack } from "../../../assets/img/icon/error_black_24dp.svg";
import { ReactComponent as HourGlass } from "../../../assets/img/icon/hourglass_full_black_24dp.svg";
import respinos from "../../../assets/img/logo/Logo Respinos 3.png";
import { COLOR } from "../../../config/constant";
import { postUserVerification } from "../../../services/httpService/userRequest";

const Verification = (props) => {
  const isMounted = useRef(true);
  const [state, setState] = useState({
    isLoading: true,
    result: "",
  });

  const handleVerification = async () => {
    try {
      const params = new URLSearchParams(props.location.search);
      const key = params.get("key");
      await postUserVerification({ key });
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        result:
          "Akun Anda sudah diverifikasi. Terima kasih telah menggunakan Respinos.",
      }));
    } catch (error) {
      let message = error.message;
      if (message === "Network Error") {
        message = `Error : Ada kesalahan jaringan. Silakan coba lagi.`;
      } else if (message.includes("username")) {
        message = `Error : Anda sudah memverifikasi akun`;
      } else {
        message = `Error : Link tidak valid. Silakan periksa tautan verifikasi Anda.`;
      }
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        result: message,
      }));
    }
  };

  useEffect(() => {
    handleVerification();
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <div className="h-screen relative font-light bg-gradient-to-tr from-primary to-gray-100">
        <div className="h-full xl:container mx-auto px-2 sm:px-6 md:px-8 lg:px-10 pt-10 sm:pt-16 lg:pt-24 xl:pt-32">
          <div className="bg-white overflow-hidden rounded-xl shadow-xl w-4/5 sm:w-112 m-auto">
            <div className="px-4 py-3 sm:px-6 sm:py-6">
              <img src={respinos} alt="" className="mt-1 h-12 mx-auto" />
              <h1 className="mt-6 text-xl font-semibold text-center">
                Verifikasi Akun
              </h1>
              <div className="mt-3 text-sm md:text-base text-center">
                {state.result !== "" ? (
                  <>
                    {state.result.includes("Error") ? (
                      <>
                        <ErrorBlack
                          className="mx-auto h-10 w-10"
                          fill={COLOR.WARNING}
                        />
                        <p className="mt-2">{state.result}</p>
                        <div className="mt-2">
                          Kembali ke{" "}
                          <Link to="/">
                            <span className="rounded-lg text-red-900 hover:text-opacity-70 underline mx-1">
                              Home
                            </span>
                          </Link>
                        </div>
                      </>
                    ) : (
                      <>
                        <CheckCircle
                          className="mx-auto h-10 w-10"
                          fill={COLOR.PRIMARY}
                        />
                        <p className="mt-2">{state.result}</p>
                        <div className="mt-2">
                          Klik{" "}
                          <Link to="/login">
                            <span className="rounded-lg text-red-900 hover:text-opacity-70 underline mx-1">
                              di sini
                            </span>
                          </Link>
                          untuk ke halaman login.
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div className="">
                      <HourGlass
                        className="mx-auto animate-pulse h-8 w-8"
                        fill={COLOR.PRIMARY}
                      />
                    </div>
                    <p className="mt-2">
                      Akun Anda sedang dalam verifikasi. Verifikasi akan memakan
                      waktu. Tolong jangan tutup browser.
                    </p>
                  </>
                )}
              </div>

              <p className="mt-6 text-gray-900 text-opacity-80 text-xs md:text-sm bg-gray-200 px-2 py-1 rounded-lg">
                <span className="font-semibold">Catatan:</span> Jika Anda
                memiliki masalah verifikasi, silakan hubungi admin Anda.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
